<div class="loading-screen">
  <div class="loading-box">
    <span class="loading-orb orb-1"></span>
    <span class="loading-orb orb-2"></span>
    <span class="loading-orb orb-3"></span>

    <div class="loading-ring"></div>

    <img src="/assets/loading.webp" alt="Loading" class="loading-gif" />

    <span class="loading-dots"></span>
  </div>
</div>